var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgSmile = function SvgSmile(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4143 43.75C35.7482 43.75 44.1255 35.3553 44.1255 25C44.1255 14.6447 35.7482 6.25 25.4143 6.25C15.0804 6.25 6.70312 14.6447 6.70312 25C6.70312 35.3553 15.0804 43.75 25.4143 43.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3975 23.4375C19.6892 23.4375 20.7364 22.3882 20.7364 21.0938C20.7364 19.7993 19.6892 18.75 18.3975 18.75C17.1057 18.75 16.0586 19.7993 16.0586 21.0938C16.0586 22.3882 17.1057 23.4375 18.3975 23.4375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4287 23.4375C33.7205 23.4375 34.7676 22.3882 34.7676 21.0938C34.7676 19.7993 33.7205 18.75 32.4287 18.75C31.137 18.75 30.0898 19.7993 30.0898 21.0938C30.0898 22.3882 31.137 23.4375 32.4287 23.4375Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5171 29.6869C32.6956 31.1123 31.5142 32.2959 30.0916 33.1188C28.6691 33.9417 27.0554 34.3749 25.4129 34.3749C23.7703 34.3749 22.1566 33.9417 20.734 33.1188C19.3115 32.2959 18.1301 31.1123 17.3086 29.687",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSmile;